import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { UserService } from '../../services/user-service/user.service';

@Component({
  selector: 'app-trip-rating-dialog',
  templateUrl: './trip-rating-dialog.component.html',
  styleUrls: ['./trip-rating-dialog.component.css']
})
export class TripRatingDialogComponent implements OnInit, AfterViewInit {
  errorMessage;
  submitted;
  alreadyRated = false;
  payload = {
    userid: null,
    tripid: null,
    rating: 0,
    driver: 0,
    vehicle: 0,
    app: 0,
    comment: "",
    details: null
  };
  constructor(private userService: UserService, private dialog: MatDialog,
    public dialogRef: MatDialogRef<TripRatingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.payload.details = data.line;
    this.payload.userid = data.userid;
    this.payload.tripid = data.line.tripId;
  }
  ngAfterViewInit(): void {
    this.userService.getRatings(this.payload.userid, this.payload.tripid).then((result: any) => {
      if (result.status && result.data.length > 0) {
        this.payload.app = result.data[0].app;
        this.payload.rating = result.data[0].stars;
        this.payload.vehicle = result.data[0].vehicle;
        this.payload.driver = result.data[0].driver;
        this.payload.comment = result.data[0].comments;
        this.alreadyRated = true;
      } else {
        this.alreadyRated = false;
      }


    }).catch(e => {
      //Still load the reportLines

    })
  }

  ngOnInit() {

  }

  submit() {
    this.errorMessage = "";
    if(this.payload.app == 0 || this.payload.driver == 0 || this.payload.rating == 0 
      || this.payload.vehicle == 0 || this.payload.comment == "" || !this.payload.comment){
        this.errorMessage = "Please give a rating to each category and leave a comment";
        return;
    }
    this.userService.rateTrip(this.payload).then((result: any) => {
      if (result.status) {
        this.submitted = "Your rating and comment have been submitted. Thank you!"
        setTimeout(() =>{
          this.dialogRef.close({
            message: "Thanks you for your feedback regarding this trip.",
            title: "Thank you"
          });
        },4000);
      } else {

        if (result.code == 100) {
          this.errorMessage = "You are not allowed to rate the trip until the drop off time has elapsed. Please try again in day or a couple hours.";
        } else {
          this.errorMessage = "There was a problem when rating the trip. Please try again later.";
        }

      }

    }).catch(e => {
      this.errorMessage = "There was a problem when rating the trip. Please try again later.";;
    });
  }

}
